exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Answers{padding:10px 0}.Answers .title{font-size:14px;color:rgba(0,0,0,.65);font-weight:700;margin-bottom:4px}.Answers .AnswerInput{position:relative;padding-bottom:20px}.Answers .AnswerInput .answer-component{margin-bottom:0}.Answers .AnswerInput .error-message{color:#a94442;position:absolute;font-size:12px}.Answers .error-message{color:#a94442;font-size:14px;margin-bottom:10px}.ant-popover{z-index:1112}.procent{color:#00adff;padding:0 10px;font-size:14px;min-width:64px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/components/components/Answers.scss
// module id = 4943
// module chunks = 0